const { differenceInCalendarDays, lightFormat, parseISO } = require('date-fns');

const blankDay = (usId, today) => ({
  us_id: usId,
  today,
  new_problems: 0,
  learn_problems: 0,
  review_problems: 0,
  quick_looks: 0,
  minutes_watched: 0,
  goal_reached: 0,
  emptied_study_queue: 0,
  points: 0,
});

/** Streak, vacation days and multiplier carried over from the last day studied. */
function carryStreak(prev, now) {
  let daysInARow = prev.days_in_a_row;
  let usedVacationDays = prev.used_vacation_days;
  if (!prev.goal_reached) usedVacationDays += 1;
  usedVacationDays += differenceInCalendarDays(now, parseISO(prev.today)) - 1;
  if (Math.floor((daysInARow + 4) / 7) < usedVacationDays) {
    daysInARow = 0;
    usedVacationDays = 0;
  }
  const multiplier = daysInARow < 2 ? 1 : Math.min(daysInARow, 5);
  return { days_in_a_row: daysInARow, used_vacation_days: usedVacationDays, multiplier };
}

/**
 * Stats rows (newest first) with a record for today on top, so the store can be set in one commit.
 * Returns rows itself when today's record is already there.
 */
function statsWithToday(rows, usId, now) {
  const today = lightFormat(now, 'y-MM-dd');
  if (rows.length && rows[0].today === today) return rows;
  const carried = rows.length ? carryStreak(rows[0], now) : { days_in_a_row: 0, used_vacation_days: 0, multiplier: 1 };
  return [{ ...blankDay(usId, today), ...carried }, ...rows];
}

const activity = (r) =>
  r.new_problems + r.learn_problems + r.review_problems + r.quick_looks + r.minutes_watched;

/**
 * Loaded stats, keeping the store's today record when it has more activity: a studied or minutes-watched
 * reply that landed while the load was in flight is newer than the loaded rows. Returns loaded itself otherwise.
 */
function keepNewerToday(loaded, current) {
  const mine = current && current[0];
  if (!mine || !loaded.length || mine.today !== loaded[0].today) return loaded;
  return activity(mine) > activity(loaded[0]) ? [mine, ...loaded.slice(1)] : loaded;
}

module.exports = { keepNewerToday, statsWithToday };
